import { CredentialsDto } from '@entities/user';

import {
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  LOCAL_STORAGE_REFRESH_TOKEN_KEY,
  LOCAL_STORAGE_USER_ID_KEY,
} from '../contants';

export class AuthService {
  public static setCredentialsToLocalStorage(credentials: CredentialsDto) {
    const { accessToken, refreshToken, userId } = credentials;

    localStorage.setItem(LOCAL_STORAGE_USER_ID_KEY, userId);
    localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, refreshToken);
  }

  public static getCredentialsFromLocalStorage() {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    const refreshToken = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);
    const userId = localStorage.getItem(LOCAL_STORAGE_USER_ID_KEY);

    return {
      userId,
      accessToken,
      refreshToken,
    };
  }

  public static clearStorage() {
    localStorage.clear();
  }

  public static getRefreshTokenReqDto() {
    const userId = localStorage.getItem(LOCAL_STORAGE_USER_ID_KEY);
    const refreshToken = localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY);

    if (!refreshToken || !userId) {
      return;
    }

    const reqBody: Omit<CredentialsDto, 'accessToken'> = {
      userId,
      refreshToken,
    };

    return reqBody;
  }
}
